import React from 'react';
import { call, put, takeLatest } from 'redux-saga/effects';

import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';
import { promptToast } from '../../../components/toast-container/actions';
import actions, {
  REMOVE_LIST_ITEM_REQUEST,
  RESTORE_LIST_ITEM_REQUEST,
} from '../actions/lists';
import Undo from '../undo';

export function* removeListItem({ id, listId }) {
  try {
    const response = yield call(
      graphql,
      `mutation listItemDelete($id: Int!, $listId: Int!) {
        listItemDelete(id: $id, listId: $listId) {
          restoreToken
        }
      }`,
      {
        id,
        listId,
      }
    );

    if (response.errors) {
      yield put(actions.removeListItemError(response.errors[0]));
      return;
    }

    const { restoreToken } = response.data.listItemDelete;

    yield put(actions.removeListItemSuccess(restoreToken, id, listId));

    yield put(
      promptToast(
        'success',
        <>
          {window.APP_GLOBALS.t('lists', 'confirm.item-deleted')}
          <Undo undo={actions.restoreListItemRequest(id, restoreToken)} />
        </>
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.removeListItemError(err));
  }
}

export function* restoreListItem({ restoreToken, id }) {
  try {
    const response = yield call(
      graphql,
      `mutation restoreItem($token: String!) {
        restoreItem(token: $token) {
          success
        }
      }`,
      {
        token: restoreToken,
      }
    );

    if (response.errors) {
      yield put(actions.restoreListItemError(response.errors[0]));
      return;
    }

    yield put(actions.restoreListItemSuccess(id, restoreToken));

    yield put(
      promptToast(
        'success',
        window.APP_GLOBALS.t('lists', 'confirm.item-restored')
      )
    );
  } catch (err) {
    yield call(captureException, err);
    yield put(actions.restoreListItemError(err));
  }
}

function* mySaga() {
  yield takeLatest(REMOVE_LIST_ITEM_REQUEST, removeListItem);
  yield takeLatest(RESTORE_LIST_ITEM_REQUEST, restoreListItem);
}

export default mySaga;
